<p-drawer
  [visible]="display"
  position="right"
  (onHide)="onHide()"
  appendTo="body">
  <div class="mb-2 left-sidebar">
    <h2 class="mb-3">Move To Freight</h2>
    <div class="form-group has-float-label mb-4">
      <label class="form-label" for="salesOrderSelected"
        >Sales Order <span class="madatory-field">*</span></label
      >
      <p-select
        [(ngModel)]="salesOrderSelected"
        [options]="salesOrderIdList"
        optionValue="SalesOrderID"
        optionLabel="SalesOrderID"
        [showClear]="true"
        [filter]="true"
        (onClear)="onSalesOrderSelectionClear()">
      </p-select>
    </div>
    <div class="form-group has-float-label mb-4">
      <label class="form-label" for="postingDate">Posting Date</label>
      <p-datePicker
        jniAutoCompleteBlocker
        name="postingDate"
        dataType="string"
        id="postingDate"
        class="w-full"
        [ngModel]="postingDate | date: 'MM/dd/yyyy'"
        (onFocus)="onFromDateSelection($event)" />
    </div>
    <!-- <button
      class="btn btn-primary me-3 post"
      type="submit"
      (click)="onSubmit()"
      [disabled]="!salesOrderSelected?.length">
      Post
    </button> -->

    <p-button
      label="Post"
      (click)="onSubmit()"
      [disabled]="salesOrderSelected === ''" />
  </div>
</p-drawer>
